import React from 'react';
import './Button.css';

/**
 * Universal Button Component
 * @param {string} variant - primary, secondary, danger, ghost, outline
 * @param {string} size - sm, md (default), lg
 * @param {boolean} isLoading - Shows spinner and disables button
 * @param {string} icon - FontAwesome class (e.g. "fas fa-save")
 * @param {string} iconPosition - 'left' (default) or 'right'
 */
export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  isLoading = false, 
  disabled, 
  icon,
  iconPosition = 'left',
  className = '', 
  ...props 
}) {
  return (
    <button
      className={`ui-btn variant-${variant} size-${size} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && <i className="fas fa-spinner fa-spin btn-spinner"></i>}
      
      {!isLoading && icon && iconPosition === 'left' && (
        <i className={`${icon}${children ? ' btn-icon-left' : ''}`}></i>
      )}
      
      {children && <span>{children}</span>}

      {!isLoading && icon && iconPosition === 'right' && (
        <i className={`${icon}${children ? ' btn-icon-right' : ''}`}></i>
      )}
    </button>
  );
}
